// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"424":"3488167c","532":"4e445593","796":"c49176d6","972":"64e12329"}[chunkId] + ".css";
};